import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { downloadFile } from "./gateway";
import { enqueueSnackbar } from "notistack";
import fileDownload from "js-file-download";

export const useDownloadFile = () => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: downloadFile,
    mutationKey: "downloadFile",
    onSuccess: (data) => {
      const filename = decodeURIComponent(
        data.headers["content-disposition"].split("filename*=utf-8''")[1],
      );
      fileDownload(data.data, filename);
      enqueueSnackbar(t("Επιτυχής λήψη"), { variant: "success" });
    },
  });
};
